import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import authenReducer from './authen.reducers';
import branchReducers from './branch.reducers';
import chargeReducer from './charge.reducers';
import companyReducers from './company.reducers';
import dashboardReducer from './dashboard.reducers';
import deviceReducer from './device.reducers';
import transferReducer from './transfer.reducers';
import billingReducer from './billing.reducers';
import qrReducer from './qr.reducers';

const rootReducer = history =>
  combineReducers({
    router: connectRouter(history),
    authen: authenReducer,
    billing: billingReducer,
    branch: branchReducers,
    charge: chargeReducer,
    company: companyReducers,
    dashboard: dashboardReducer,
    device: deviceReducer,
    transfer: transferReducer,
    qr: qrReducer
  });

export default rootReducer;
